
import React, { useEffect, useRef, useState } from "react";
import "./RevealBlurFX.css"; // Ensure the CSS file is linked

const RevealBlurFX = ({ children }) => {
  const containerRef = useRef(null);
  const [blurValue, setBlurValue] = useState(10); // Start with max blur
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const ratio = entry.intersectionRatio; // How much is visible (0 to 1)
          setBlurValue((1 - ratio) * 10); // Dynamically calculate blur (10 to 0)
          if (ratio >= 0.5) setIsVisible(true); // Mark visible when 50% is in view
        }
      },
      { threshold: Array.from({ length: 11 }, (_, i) => i / 10) } // Thresholds from 0 to 1
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`reveal-container ${isVisible ? "visible" : ""}`}
      style={{ "--blur": `${blurValue}px` }}
    >
      {children}
    </div>
  );
};

export default RevealBlurFX;
